import React from 'react';

// ════════════════════════════════════════════════════════════════════════════
// iconesRotinas.jsx — r105
// ────────────────────────────────────────────────────────────────────────────
// SVGs das rotinas do portal, idênticos aos do Sidebar lateral. Centralizar
// aqui evita duplicação e garante que ao trocar um ícone no Sidebar, todas as
// telas que usam o ícone (no header da page, na primeira coluna do browse,
// etc) acompanham automaticamente.
//
// Convenção: viewBox 0 0 16 16, currentColor pra cor, herdada do contexto.
//
// Uso:
//   {iconeDaRotina('acessos', { width: 24, height: 24, color: '#003399' })}
// ════════════════════════════════════════════════════════════════════════════

const ICONES = {
  // CADASTROS ─────────────────────────────────────────────────────────────
  'dashboard': (
    <svg viewBox="0 0 16 16" fill="none">
      <rect x="1" y="1" width="6" height="6" rx="1" fill="currentColor"/>
      <rect x="9" y="1" width="6" height="6" rx="1" fill="currentColor" opacity=".5"/>
      <rect x="1" y="9" width="6" height="6" rx="1" fill="currentColor" opacity=".5"/>
      <rect x="9" y="9" width="6" height="6" rx="1" fill="currentColor" opacity=".5"/>
    </svg>
  ),
  'usuarios': (
    <svg viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="5" r="3" fill="currentColor"/>
      <path d="M2 13c0-3 2.7-5 6-5s6 2 6 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  'grupos-acesso': (
    <svg viewBox="0 0 16 16" fill="none">
      <circle cx="5" cy="5" r="2.5" fill="currentColor" opacity=".6"/>
      <circle cx="11" cy="5" r="2.5" fill="currentColor"/>
      <path d="M1 13c0-2 1.8-3.5 4-3.5M8 13c0-2 1.8-3.5 4-3.5s4 1.5 4 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  'empresas': (
    <svg viewBox="0 0 16 16" fill="none">
      <rect x="2" y="4" width="12" height="10" rx="1" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5 4V3a1 1 0 011-1h4a1 1 0 011 1v1" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M6 9h4M6 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  'colaboradores': (
    <svg viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="4" r="2.5" fill="currentColor"/>
      <path d="M3 13c0-2.8 2.2-5 5-5s5 2.2 5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M12 7l1.5 1.5L16 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'clientes': (
    <svg viewBox="0 0 16 16" fill="none">
      <rect x="1" y="3" width="14" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M1 6h14" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="5" cy="10" r="1" fill="currentColor"/>
    </svg>
  ),
  'condicoes-pagamento': (
    <svg viewBox="0 0 16 16" fill="none">
      <rect x="1" y="4" width="14" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M1 7h14" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M3.5 10.5h2M7 10.5h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  'acessos': (
    <svg viewBox="0 0 16 16" fill="none">
      <rect x="3" y="7" width="10" height="7" rx="1" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M6 7V4.5a2 2 0 014 0V7" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="8" cy="10.5" r="1" fill="currentColor"/>
    </svg>
  ),

  // COMERCIAL ─────────────────────────────────────────────────────────────
  'crm': (
    <svg viewBox="0 0 16 16" fill="none">
      <path d="M2 12L6 8l3 3 5-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // TÉCNICA ───────────────────────────────────────────────────────────────
  'planejamento': (
    <svg viewBox="0 0 16 16" fill="none">
      <rect x="1.5" y="2.5" width="9" height="11" rx="1" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M3.5 5.5h5M3.5 8h5M3.5 10.5h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="12.5" cy="11.5" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M12.5 10.5v2M11.5 11.5h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  'lancamentos-horas': (
    <svg viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="4.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5.5 3.5L6 1h4l0.5 2.5" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.5 12.5L6 15h4l0.5-2.5" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 6v2l1.5 1" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // TAREFAS ───────────────────────────────────────────────────────────────
  'tarefas': (
    <svg viewBox="0 0 16 16" fill="none">
      <rect x="2" y="2" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5 8l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // SISTEMA ───────────────────────────────────────────────────────────────
  'horarios-colaboradores': (
    <svg viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M8 4v4l2.5 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  'periodos': (
    <svg viewBox="0 0 16 16" fill="none">
      <rect x="1.5" y="3" width="13" height="11" rx="1.5"
            stroke="currentColor" strokeWidth="1.5"/>
      <path d="M1.5 6.5h13" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5 1.5v3M11 1.5v3" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round"/>
      <rect x="6.5" y="9" width="3" height="2.5" rx="0.3"
            stroke="currentColor" strokeWidth="1.2"/>
      <path d="M7 9V8.2a1 1 0 011-1 1 1 0 011 1V9" stroke="currentColor"
            strokeWidth="1.2"/>
    </svg>
  ),

  // r227: execucao-tecnica — duas engrenagens vazadas sobrepostas, conforme o
  //       icone de referencia (icons8 "gears", estilo forma-bold). Redesenhado
  //       em SVG no padrao da casa, nao e o arquivo original.
  //       Unico icone deste arquivo em viewBox 24 (os demais sao 16); como o
  //       iconeDaRotina so define width/height, a escala sai igual a das
  //       outras rotinas.
  'execucao-tecnica': (
    <svg viewBox="0 0 24 24" fill="none">
      {/* Duas engrenagens vazadas, sobrepostas na diagonal. Os dentes são
          calculados por trigonometria (8 por engrenagem, a cada 45°) — foi
          desenhar diagonal na mão que deixou os ícones anteriores tortos. */}
      <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        {/* Engrenagem menor */}
        <circle cx="7.3" cy="6.6" r="3.2"/>
        <path d="M11.6 6.6L12.8 6.6M10.34 9.64L11.19 10.49M7.3 10.9L7.3 12.1M4.26 9.64L3.41 10.49M3 6.6L1.8 6.6M4.26 3.56L3.41 2.71M7.3 2.3L7.3 1.1M10.34 3.56L11.19 2.71"/>
        {/* Engrenagem maior */}
        <circle cx="16.6" cy="16.4" r="3.9"/>
        <path d="M21.22 18.31L22.42 18.81M18.51 21.02L19.01 22.22M14.69 21.02L14.19 22.22M11.98 18.31L10.78 18.81M11.98 14.49L10.78 13.99M14.69 11.78L14.19 10.58M18.51 11.78L19.01 10.58M21.22 14.49L22.42 13.99"/>
      </g>
    </svg>
  ),
};

// Fallback genérico (círculo) — caso a rotina seja desconhecida
const ICONE_GENERICO = (
  <svg viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);

// ────────────────────────────────────────────────────────────────────────────
// iconeDaRotina(codigo, options)
//   codigo  — código da rotina (ex: 'acessos', 'usuarios')
//   options.width / height — tamanho (default 16)
//   options.color — cor do stroke/fill (default 'currentColor')
// ────────────────────────────────────────────────────────────────────────────
export function iconeDaRotina(codigo, { width = 16, height = 16, color = 'currentColor' } = {}) {
  const svg = ICONES[codigo] || ICONE_GENERICO;
  return React.cloneElement(svg, {
    width, height, style: { color, flexShrink: 0 },
  });
}

// Lista de rotinas com ícone disponível (útil pra debug ou docs)
export const ROTINAS_COM_ICONE = Object.keys(ICONES);
